import { createContext, useContext, useState } from "react";

const dailyDataCollection = createContext();

export const CollectionProvider = (props) => {
    const [daily, setDaily] = useState(() => {
            const saved = localStorage.getItem('collectionAmount');
            return saved ? JSON.parse(saved) : null;
        });

        return (
            <dailyDataCollection.Provider value={{ ...props, daily, setDaily}}>
                {props.children}
            </dailyDataCollection.Provider>
        )
}

export const useCollection = () => useContext(dailyDataCollection);